import {
  GiftIcon,
  PawPrintIcon,
  WrenchIcon,
  type LucideIcon,
} from "lucide-react";

import type { ShopMode } from "./types";

import { Row } from "@/components/Row";
import { Button } from "@ui/button";

import { cn } from "@/lib/utils";

const modeDetails: Record<ShopMode, { label: string; icon: LucideIcon }> = {
  CUSTOMIZE: { label: "Customize", icon: PawPrintIcon },
  CUSTOM: { label: "Custom Lab", icon: WrenchIcon },
  INCENTIVES: { label: "Incentives", icon: GiftIcon },
};

export const ShopModeTabs = ({
  modes,
  selectedMode,
  onSelect,
}: {
  modes: ShopMode[];
  selectedMode: ShopMode;
  onSelect: (mode: ShopMode) => void;
}) => {
  return (
    <Row>
      {modes.map((mode) => {
        const Icon = modeDetails[mode].icon;
        return (
          <Button
            key={mode}
            type="button"
            variant="outlineDark"
            onClick={() => {
              onSelect(mode);
            }}
            className={cn(
              "-ml-0.5 h-9 gap-1.5 rounded-none border-2 border-slate-900 px-3 font-mono text-[10px] font-black uppercase tracking-[0.08em] first:ml-0",
              selectedMode === mode
                ? "bg-orange-400 text-white hover:bg-orange-500 hover:text-white"
                : "bg-white text-slate-900 hover:bg-orange-50",
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            {modeDetails[mode].label}
          </Button>
        );
      })}
    </Row>
  );
};
